// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_wKVQ4 {
  width: 100%;
  height: 100%;
  aspect-ratio: 1 / 2;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 0;
  background: var(--white-background);
}

.row_J5Zo2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  background: var(--white-background);
  border-radius: 8px;
}

.rowBorderBottom_Mp601 {
  border-bottom: 1px solid var(--ccc-border);
}


.labelBold_GLyg7 {
  font-weight: bold;
  color: var(--_3-color);
}

.greyText_t3kzr {
  color: var(--888-contacts-color);
}

.blackText_Iakki {
  color: var(--black-color);
  font-weight: 500;
}


.blockGroup_CDwMa {
  background: var(--white-background);
  border: 1px solid var(--ccc-border);
  border-radius: 12px;
  overflow: hidden;
}

.groupRow_vivvx {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid var(--e-border);
  padding: 20px 16px;
}

.topRadius_PDGfu {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  border-top: none;
}

.bottomRadius_yYw8j {
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}

.limitControls_DknWc {
  display: flex;
  align-items: center;
  gap: 6px;
}

.controlButton_a5fa5 {
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 6px;
  background: var(--e-border);
  font-size: 16px;
  cursor: pointer;
}

.limitInput_I98fM {
  width: 80px;
  padding: 4px;
  border: 1px solid var(--ccc-border);
  border-radius: 6px;
  text-align: center;
  background-color: var(--f6-background);
}

.displayColumn_usrJd{
    display: flex;
    flex-direction: column;
    gap: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/GeneralSettings/components/GetPlus/GetPlus.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;AAC5C;;;AAGA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;;AAGA;EACE,mCAAmC;EACnC,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,kBAAkB;EAClB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb","sourcesContent":[".container {\n  width: 100%;\n  height: 100%;\n  aspect-ratio: 1 / 2;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 16px 0;\n  background: var(--white-background);\n}\n\n.row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 12px;\n  background: var(--white-background);\n  border-radius: 8px;\n}\n\n.rowBorderBottom {\n  border-bottom: 1px solid var(--ccc-border);\n}\n\n\n.labelBold {\n  font-weight: bold;\n  color: var(--_3-color);\n}\n\n.greyText {\n  color: var(--888-contacts-color);\n}\n\n.blackText {\n  color: var(--black-color);\n  font-weight: 500;\n}\n\n\n.blockGroup {\n  background: var(--white-background);\n  border: 1px solid var(--ccc-border);\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.groupRow {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-top: 1px solid var(--e-border);\n  padding: 20px 16px;\n}\n\n.topRadius {\n  border-top-left-radius: 12px;\n  border-top-right-radius: 12px;\n  border-top: none;\n}\n\n.bottomRadius {\n  border-bottom-left-radius: 12px;\n  border-bottom-right-radius: 12px;\n}\n\n.limitControls {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.controlButton {\n  width: 28px;\n  height: 28px;\n  border: none;\n  border-radius: 6px;\n  background: var(--e-border);\n  font-size: 16px;\n  cursor: pointer;\n}\n\n.limitInput {\n  width: 80px;\n  padding: 4px;\n  border: 1px solid var(--ccc-border);\n  border-radius: 6px;\n  text-align: center;\n  background-color: var(--f6-background);\n}\n\n.displayColumn{\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_wKVQ4`,
	"row": `row_J5Zo2`,
	"rowBorderBottom": `rowBorderBottom_Mp601`,
	"labelBold": `labelBold_GLyg7`,
	"greyText": `greyText_t3kzr`,
	"blackText": `blackText_Iakki`,
	"blockGroup": `blockGroup_CDwMa`,
	"groupRow": `groupRow_vivvx`,
	"topRadius": `topRadius_PDGfu`,
	"bottomRadius": `bottomRadius_yYw8j`,
	"limitControls": `limitControls_DknWc`,
	"controlButton": `controlButton_a5fa5`,
	"limitInput": `limitInput_I98fM`,
	"displayColumn": `displayColumn_usrJd`
};
export default ___CSS_LOADER_EXPORT___;
